__turbopack_context__.v({
  "phoneButton": "phoneInput-module-scss-module__l6vyLW__phoneButton",
  "phoneContainer": "phoneInput-module-scss-module__l6vyLW__phoneContainer",
  "phoneDropdown": "phoneInput-module-scss-module__l6vyLW__phoneDropdown",
  "phoneDropdownWrp": "phoneInput-module-scss-module__l6vyLW__phoneDropdownWrp",
  "phoneInput": "phoneInput-module-scss-module__l6vyLW__phoneInput",
  "phoneWrp": "phoneInput-module-scss-module__l6vyLW__phoneWrp",
  "small": "phoneInput-module-scss-module__l6vyLW__small",
});
